import { BadgeCheck } from "lucide-react";

export const VerifiedBadge = ({ size = "sm", showLabel = false, className = "" }) => {
  const icon = size === "xs" ? "h-3.5 w-3.5" : "h-4 w-4";
  return (
    <span data-testid="verified-badge" title="Photo verified" className={`inline-flex items-center gap-1 text-sky-300 ${className}`}>
      <BadgeCheck className={`${icon} fill-sky-500/30`} />
      {showLabel && <span className="text-[11px] font-bold uppercase tracking-wide">Verified</span>}
    </span>
  );
};
